<template>
  <div class="internal-job-pool-container">
    <b-row class="d-flex justify-content-between align-items-center mx-1">
      <div class="d-flex flex-row">
        <h4>
          <template v-if="loading">Loading...</template>
          <template v-else>{{ results.edges.length | plural('result') }}</template>
        </h4>
      </div>
    </b-row>

    <!-- matched users card -->
    <b-card class="mt-3" v-if="results && Array.isArray(results.edges)">
      <b-row class="pb-3 border-bottom">
        <b-col class="block-title">Matched Jobs</b-col>
      </b-row>
      <b-row>
        <b-col class="px-0">
          <b-table
            table-class="m-0"
            hover responsive show-empty
            :fields="fields"
            :items="results.edges"
            :per-page="10"
            :current-page="page"
            :busy="false"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template #cell(buttons)="{ item }">
              <b-button
                variant="primary"
                class="ml-2"
                @click="selectedJob = item"
                v-b-modal="'profile-contact-modal'"
              >Contact</b-button>
            </template>
          </b-table>

          <b-card class="mt-3 border-0" body-class="d-flex flex-row p-3 justify-content-center align-items-center">
            <b-pagination
              class="m-0"
              v-model="page"
              :per-page="limit"
              :total-rows="total"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- User Profile Contact Modal -->
    <b-modal
      id="profile-contact-modal"
      :title="`Contact ${talent.fullName}`"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <b-form-group label-for="subject">
        <h4><b>From Name</b></h4>
        <p class="text-muted">Edit the name of the sender.</p>
        <b-form-input
          type="text"
          v-model="contactForm.fromName"
        ></b-form-input>
      </b-form-group>
      <b-form-group label-for="subject">
        <h4><b>Subject</b></h4>
        <p class="text-muted">If you select "Recommend this opening" your message will be sent along with a link to this job.</p>
        <b-form-select
          :options="[
            { value: 'RECOMMEND_JOB', text: 'Recommend this opening' },
            { value: 'CONTACT_USER', text: 'Contact user' },
          ]"
          v-model="contactForm.subject"
        ></b-form-select>
      </b-form-group>
      <b-form-group>
        <h4><b>Message</b></h4>
        <p class="text-muted">This text will be sent to {{ talent ? talent.fullName : '' }} as an email from the platform.</p>
        <tip-tap-editor ref="tipTapEditor" :value="contactForm.message" @input="value => contactForm.message = value"/>
      </b-form-group>
      <b-button
        variant="primary"
        class="float-right"
        @click="sendEmail"
      >
        Send Email
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import ProfileShow from '@/components/profile/ProfileShow';
import TipTapEditor from '@/components/misc/TiptapEditor';
import { mapRoot } from '@src/mixins/root';

const defaultEmailContent = ctx => `
  <p>Hi ${ctx.talent ? ctx.talent.firstName : ''},</p>
  <p>I believe you would be a great match for this opening.</p>
  <p>You can take a look at this opportunity by clicking the button below.</p>
  <p>Best,</p>
  <p>Your Hiring Team</p>
`;

export default {
  name: 'InternalTalentPoolContainer',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    hidePagination: {
      type: Boolean,
      default: () => false,
    },
    talent: {
      type: Object,
      default: () => null,
    },
    jobs: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    ProfileShow,
    LoadingSpinner,
    TipTapEditor,
  },
  watch: {
    selectedJob() {
      this.contactForm.message = defaultEmailContent(this);
    },
    contactForm: {
      deep: true,
      handler() {
        if (this.contactForm.subject === 'RECOMMEND_JOB') {
          if (this.contactForm.message.trim() === '') {
            this.contactForm.message = defaultEmailContent(this);
            this.$refs.tipTapEditor.setContent(defaultEmailContent(this));
          }
        } else {
          if (this.contactForm.message === defaultEmailContent(this)) {
            this.contactForm.message = '';
            this.$refs.tipTapEditor.setContent('');
          }
        }
      },
    },
  },
  data() {
    return {
      results: {
        edges: this.jobs ? this.jobs : []
      },
      showHorizontalWhere: true,
      where: {
        title: '',
        skills: [],
        location: null,
      },
      page: 1,
      limit: 10,
      total: (this.jobs ? this.jobs : []).length,
      totalPages: Math.ceil((this.jobs ? this.jobs : []).length / 10),
      selectedJob: null,
      contactForm: {
        subject: 'RECOMMEND_JOB',
        message: '',
        fromName: 'Hiring Team',
      }
    };
  },
  computed: {
    ...mapRoot([ 'company', 'user' ]),
    fields() {
      return [
        {
          key: 'title',
          label: 'Title',
          thStyle: { width: '600px' },
        },
        {
          key: 'buttons',
          label: '',
          thStyle: { width: '100px' },
        },
      ];
    },
  },
  methods: {
    sendEmail() {
      this.$emit('sendContactEmail', { contactForm: this.contactForm, talent: this.talent, job: this.selectedJob });
      this.$bvModal.hide('profile-contact-modal');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/projects/InternalJobPoolContainer.vue